export default "__VITE_ASSET__BKyM94T1__"